<template>
    <form class="g pop-up-inner">
        <mdToggleAside
            @sendEvent="close"
        ></mdToggleAside>
        <mdCaption
            caption="編輯日曆本"
        ></mdCaption>
        <div class="g pop-up-content">
            <div class="g pop-up-content-inner">
                <div class="md form-table">
                    <table>
                        <tr>
                            <th><label for="sub">標題</label></th>
                            <td>
                                <div class="cp input text" :class="[errors.has('sub')? 'is-error': '']" :data-error="errors.first('sub')">
                                    <input v-if="editable" v-model="sub" type="text" v-validate="'required'" name="sub" id="sub">
                                    <input v-else :value="sub" type="text" disabled>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <th><label for="desc">權限</label></th>
                            <td>
                                <span v-if="editable">可編輯</span>
                                <span v-else>不可編輯</span>
                            </td>
                        </tr>
                        <tr>
                            <th><label for="color">顏色</label></th>
                            <td>
                                <div class="cp input color" :class="[errors.has('color')? 'is-error': '']" :data-error="errors.first('color')">
                                    <input v-if="editable" v-model="color" type="color" v-validate="'required'" name="color" id="color">
                                    <input v-else :value="color" type="color" disabled>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <th><label for="desc">敘述</label></th>
                            <td>
                                <textarea v-if="editable" v-model="desc" id="desc"></textarea>
                                <textarea v-else :value="desc" disabled></textarea>
                            </td>
                        </tr>
                    </table>
                </div>
            </div>
        </div>
        <mdBtnList
            :content="btns"
            :block="true"
            @sendEvent="receiveEvent"
        ></mdBtnList>
    </form>
</template>

<script>
    import mdCaption from '@/components/mdCaption'
    import mdToggleAside from '@/components/mdToggleAside'
    import mdBtnList from '@/components/mdBtnList'

    export default {
        components: {
            mdCaption,
            mdToggleAside,
            mdBtnList,
        },
        props: {
            sn: {
                require: true
            },
            content: {
                type: Object,
                require: true
            }
        },
        data: function(){
            return {
                calsn: null,
                sub: null,
                color: null,
                desc: null,
                editable: null
            }
        },
        computed: {
            btns: function(){

                let $edit = {
                        text: this.$t('site.status.confirm'),
                        themes: 'major',
                        func: 'edit',
                    },
                    $danger = {
                        text: this.$t('site.func.remove'),
                        themes: 'danger',
                        func: 'remove',
                    },
                    $cancel = {
                        text: this.$t('site.func.popupclose'),
                        func: 'close',
                    }

                return [
                    $edit,
                    $danger,
                    $cancel,
                ]
            },
        },
        methods: {
            edit: function(){

                this.$validator.validate().then(result => {
                    if (!result){
                        console.log('沒通過');
                    }else {
                        this.content.extend.updateSource({
                            sn: this.calsn,
                            sub: this.sub,
                            desc: this.desc,
                            color: this.color,
                            active: true,
                            editable: true
                        });

                        this.close();
                    }
                });
            },
            remove: function(){
                this.content.extend.confirmRemoveSource({
                    sn: this.calsn
                });
            },
            close: function(){
                this.$emit('sendEvent', 'clearPopUp', this.sn);
            }
        },
        created: function(){ //先把綁進來的資料格式化到 date
            let $node = this.content.node;

            this.sub = $node.sub;
            this.color = $node.color;
            this.desc = $node.desc;
            this.editable = $node.editable;
            this.calsn = $node.sn;
        }
    }
</script>

<style scoped lang="scss">

    textarea {
        min-height: 60px;
    }
</style>
